import { Component, inject, signal } from '@angular/core';
import { ScreenNavigationService } from '../../core/services/screen-navigation';
import { ThemeCatalogService } from '../../core/services/theme-catalog';
import { DailyChallengeService } from '../../core/services/daily-challenge';
import { ThemePicker } from '../../shared/components/theme-picker/theme-picker';
import { Theme } from '../../core/models/responses/theme';

/** Escolha de tema do Desafio Diário — 1º passo; o dia é escolhido em seguida (daily-calendar). */
@Component({
  selector: 'app-daily-theme',
  imports: [ThemePicker],
  templateUrl: './daily-theme.html',
  styleUrl: './daily-theme.scss',
})
export class DailyThemePage {
  private readonly screenNavigation = inject(ScreenNavigationService);
  private readonly themeCatalog = inject(ThemeCatalogService);
  private readonly dailyChallenge = inject(DailyChallengeService);
  protected readonly themes = signal<Theme[]>([]);
  protected readonly isLoadingThemes = signal(true);

  ngOnInit(): void {
    this.themeCatalog.loadQuemSouEu().subscribe({
      next: (themes) => {
        this.themes.set(themes);
        this.isLoadingThemes.set(false);
      },
      error: (error: unknown) => {
        console.error('Não foi possível carregar os temas.', error);
        this.isLoadingThemes.set(false);
      },
    });
  }

  protected onBackClick(): void {
    this.screenNavigation.goToHome();
  }

  protected onThemeClick(theme: Theme): void {
    this.dailyChallenge.selectTheme(theme);
    this.screenNavigation.goToDailyCalendar();
  }
}
